module.exports = __webpack_public_path__ + "b14bf44311bd11daa460c55aa249954c.svg";